import { render, staticRenderFns } from "./PersonnelRecordDetailsTabAttendances.vue?vue&type=template&id=f4083814"
import script from "./PersonnelRecordDetailsTabAttendances.vue?vue&type=script&lang=js"
export * from "./PersonnelRecordDetailsTabAttendances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports